module.exports = function getResource(label, vars = []) {
    const resources = {
        close: 'Close',
        shopNow: 'Shop Now Pay Later',
        interestFree: 'Pay 4 installments of',
        interestFreeDescription: 'Pay 4 interest-free installments so you can spread the cost, with no additional fees when paid on time.',
        addItems: 'Add item(s) to your cart',
        chooseAfterpayOrKlarna: 'Go to checkout and choose Klarna or Afterpay',
        chooseAfterpay: 'Go to checkout and choose Afterpay',
        chooseKlarna: 'Go to checkout and choose Klarna',
        enterCardInfo: 'Enter your debit or credit card information',
        payLater: 'Pay later in 4 installments. The first payment is taken when the order is processed and the remaining 3 are automatically taken at scheduled intervals',
        learnMore: 'Learn more',
        gotIt: 'Got It'
    };

    return resources[label];
};
